import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImagesOverview from './ImagesOverview'
import ImagesGallery from './ImagesGallery'
import './Images.css'

class Images extends Component {
	constructor(props) {
		super(props)
		this.state = {
			activeTab: 'overview', // 'overview' or 'gallery'
			
			// Shared filter state
			availableClients: [],
			selectedClientId: '',
			loadingClients: true,
			startDate: '',
			endDate: '',
			photographerName: '',
			clientImageId: '',
			supplier: '',
			
			// Images data
			images: [],
			loading: false,
			page: 1,
			pageSize: 50,
			totalImages: 0,
			
			// Sorting
			sortColumn: null,
			sortDirection: 'asc',
		}
	}

	handleTabChange = (tab) => {
		this.setState({ activeTab: tab })
	}
	
	// Callback to update shared state from child components
	updateSharedState = (updates) => {
		this.setState(updates)
	}

	render() {
		const { activeTab, ...sharedState } = this.state
		const { client_ids } = this.props

		return (
			<div className="images-container">
				<div className="images-header">
					<h1 className="images-title">Images</h1>
					<p className="images-subtitle">Browse and search through image data</p>
				</div>

				{/* Tabs */}
				<div className="images-tabs">
					<button
						className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
						onClick={() => this.handleTabChange('overview')}
					>
						Overview
					</button>
					<button
						className={`tab-button ${activeTab === 'gallery' ? 'active' : ''}`}
						onClick={() => this.handleTabChange('gallery')}
					>
						Gallery
					</button>
				</div>

				{/* Tab Content */}
				<div className="tab-content">
					{activeTab === 'overview' && (
						<ImagesOverview 
							client_ids={client_ids}
							sharedState={sharedState}
							updateSharedState={this.updateSharedState}
						/>
					)}
					{activeTab === 'gallery' && (
						<ImagesGallery 
							client_ids={client_ids}
							sharedState={sharedState}
							updateSharedState={this.updateSharedState}
						/>
					)}
				</div>
			</div>
		)
	}
}

Images.propTypes = {
	client_ids: PropTypes.array.isRequired,
}

Images.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default Images
